module.exports = __webpack_public_path__ + "img/banner.1d45b7b8.png";